module.exports = {
        srcSet: "/_next/static/images/jordi-solsona-183.6d915d86.webp"+" 183w",
        images: [{path: "/_next/static/images/jordi-solsona-183.6d915d86.webp",width: 183,height: 181}],
        src: "/_next/static/images/jordi-solsona-183.6d915d86.webp",
        toString: function(){return "/_next/static/images/jordi-solsona-183.6d915d86.webp"},
        
        width: 183,
        height: 181
      }